import { Component } from "react";
import View from "./view";
import "./index.css";
import {
  getFormForMachine,
  createMachineInspection,
  getMachine
} from "../../../backend/machines";
import withRouter from "react-router-dom/withRouter";
import { connect } from "react-redux";

class MachineForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      machine: props.machine,
      machine_id: props.match.params.machine_id,
      form_id: props.match.params.form_id,
      savedForm: Boolean(props.match.params.form_id),
      dialogVisible: false,
      loading: false,
      machine_hours: props.machine.machine_hours,
      status: props.machine.machine_status
    };
    this._leave = this._leave.bind(this);
    this._valid = this._valid.bind(this);
    this._toggleSubmitDialog = this._toggleSubmitDialog.bind(this);
  }

  async componentDidMount() {
    const { form_id, machine_id } = this.state;
    if (form_id || machine_id) this.setState({ loading: true });

    if (form_id) {
      this.setState({ ...(await getFormForMachine(form_id)), loading: false });
    }
    if (machine_id) {
      this.setState({ machine: await getMachine(machine_id), loading: false });
    }
  }

  _change(prop, ev = false, sel = false) {
    return event =>
      this.setState({
        [prop]: ev ? (sel ? event.value : event) : event.target.value
      });
  }

  _valid() {
    return (
      this.state.priority !== undefined &&
      this.state.machine_hours !== undefined &&
      this.state.machine_id !== undefined &&
      this.state.status !== undefined &&
      this.state.inspection_pass !== undefined &&
      this.state.inspection_note !== undefined &&
      this.state.require_swap !== undefined &&
      (this.state.require_swap === true
        ? this.state.new_machine_id !== undefined &&
          this.state.one_way_swap !== undefined
        : true)
    );
  }

  _leave(event) {
    this._toggleSubmitDialog();
  }

  _toggleSubmitDialog() {
    this.setState({ dialogVisible: !this.state.dialogVisible });
  }

  async _upload() {
    const {
      inspection_note,
      inspection_pass,
      require_swap,
      status,
      machine_hours,
      one_way_swap,
      new_machine_id,
      priority
    } = this.state;
    const { store_id } = this.state.machine;
    const { machine_id } = this.props.match.params;

    this.setState({ uploading: true });
    await createMachineInspection({
      inspection_note,
      inspection_pass,
      require_swap,
      machine_hours,
      store_id,
      priority,
      one_way_swap,
      new_machine_id,
      status,
      machine_id
    });
    this.setState({ uploading: false, savedForm: true });
    this.props.history.goBack();
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }

  render() {
    return View.call(this);
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    machine: state.selections.machine || { machine_hours: 0 }
  };
};

export default withRouter(connect(mapStateToProps)(MachineForm));



// WEBPACK FOOTER //
// ./src/screens/machines/machine-form/index.js